module.exports = __webpack_public_path__ + "media/images/top-7-0fad4ceb5313538e581ff74d348dcaef.png";